import styled from "styled-components";
import { NavLink } from "react-router-dom";

export const NavItem = styled(NavLink)`
  padding: 6px 10px;
  border-radius: 8px;
  text-decoration: none;
  color: #374151;
  font-size: 14px;

  &.active {
    background: #DEE0E5;
    color: #111827;
    font-weight: 600;
  }
`;